export const MAIN_DISPLAY = 'MAIN_DISPLAY'
export const SILENCED_DISPLAY = 'SILENCED_ALERTS'
export const SILENCED_RULES_DISPLAY = 'SILENCED_RULES_DISPLAY'
export const HISTORY_DISPLAY = 'HISTORY_DISPLAY'
export const STATS_DISPLAY = 'STATS_DISPLAY'
export const ESCALATIONS_DISPLAY = 'ESCALATIONS_DISPLAY'